var map = {
	"./경영대학.jpg": 7600,
	"./공과대학.jpg": 3369,
	"./국제대학.jpg": 5073,
	"./디자인조형학부.jpg": 3893,
	"./문과대학.jpg": 8850,
	"./미디어학부.jpg": 6604,
	"./보건과학대학.jpg": 4567,
	"./생명과학대학.jpg": 1125,
	"./스마트보안학부.jpg": 4332,
	"./심리학부.jpg": 6940,
	"./이과대학.jpg": 3654,
	"./정경대학.jpg": 5396,
	"./정보대학.jpg": 5169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8443;